export default "__VITE_ASSET__bfbc50f2__"